import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import classNames from 'classnames';
import { matchMedia } from '../../helpers/match-media';
import style from './index.module.scss'; // If the full text content fits into (minLines + buffer), just show everything by default

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BUFFER_LINES = 2;

class ShowMoreText extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "state", {
      collapsed: false,
      expanding: false,
      maxHeight: 0
    });

    _defineProperty(this, "showAll", () => {
      const timeout = parseInt(style['expand-duration-ms'], 10);
      const fullHeight = this.textWrapper.current.scrollHeight;
      this.setState({
        expanding: true,
        maxHeight: fullHeight
      });
      setTimeout(() => {
        this.setState({
          collapsed: false,
          expanding: false,
          maxHeight: 0
        });
      }, timeout);
    });

    this.textWrapper = /*#__PURE__*/React.createRef();
  }

  componentDidMount() {
    if (this.props.minLines) {
      // When a media query is provided, only collapse the text if the media query matches.
      if (this.props.matchMedia && !matchMedia(this.props.matchMedia).matches) {
        return;
      } // Calculate line height of the first non-parent element in the container.
      // This naively assumes that the first few lines of text are all the same height,
      // which is the primary use case (e.g. cinema descriptions).


      let firstLeafNode = this.textWrapper.current;

      while (firstLeafNode.firstElementChild) {
        firstLeafNode = firstLeafNode.firstElementChild;
      }

      const lineHeight = parseFloat(window.getComputedStyle(firstLeafNode).lineHeight) || 0; // Check if it needs collapsing

      const maxHeight = lineHeight * (this.props.minLines + BUFFER_LINES);

      if (this.textWrapper.current.scrollHeight > maxHeight) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState((_state, props) => ({
          collapsed: true,
          maxHeight: lineHeight * props.minLines
        }));
      }
    }
  }

  render() {
    const {
      children,
      buttonText,
      buttonStyle,
      color
    } = this.props;
    const {
      collapsed,
      expanding,
      maxHeight
    } = this.state;
    const wrapperStyle = maxHeight ? {
      maxHeight: "".concat(maxHeight, "px")
    } : {};
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        ref: this.textWrapper,
        className: classNames(style.textWrapper, {
          [style.textCollapsed]: collapsed,
          [style.greyTextCollapsed]: collapsed && color === 'Grey',
          [style.textExpanding]: expanding
        }),
        style: wrapperStyle,
        children: children
      }), collapsed && /*#__PURE__*/_jsx("div", {
        className: classNames(style.showMoreWrapper, {
          [style.showMoreExpanding]: expanding
        }),
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          className: classNames(style.showMore, buttonStyle),
          onClick: this.showAll,
          children: buttonText
        })
      })]
    });
  }

}

ShowMoreText.defaultProps = {
  buttonText: 'Show more'
};
export default ShowMoreText;